<div class="w-full">
  <app-home-header (onReady)="doComReady($event,'home-head')">
  </app-home-header>
  <div>
<!-- <ul class="menu-vertical lg:menu-horizontal bg-base-200 rounded-box">
  <li><a>常用</a></li>
  <li><a>管理</a></li>
  <li>
    <details>
      <summary>維護</summary>
      <button mat-menu-item (click)="doMenu('syspq80')">派班查詢(syspq80)</button>
      <ul>
        <li><a>All products</a></li>
        <li><a>Electronics</a></li>
        <li><a>Clothing</a></li>
      </ul>
    </details>
  </li>
</ul> -->

    @if(showMenu){
    <div class="flex bg-blue-300">
      <button mat-menu-item [matMenuTriggerFor]="m01">常用</button>
<!--       <button mat-menu-item [matMenuTriggerFor]="m05">投資</button> -->      
      <button mat-menu-item [matMenuTriggerFor]="m02">管理</button>
      <button mat-menu-item [matMenuTriggerFor]="m03">維護</button>
      <button mat-menu-item [matMenuTriggerFor]="m04">管理員</button>
    </div>
    }

    <mat-menu #m01="matMenu">
    </mat-menu>

    <mat-menu #m02="matMenu">
      <button mat-menu-item (click)="doMenu('admi10')">登入者資料建立(admi10)</button>
      <button mat-menu-item (click)="doMenu('admpi83')">個人資料設定(admpi83)</button>
      <button mat-menu-item (click)="doMenu('reportview')">報表檢視(reportview)</button>
    </mat-menu>
    <mat-menu #m03="matMenu">
      <button mat-menu-item (click)="doMenu('syspq80')">派班查詢(syspq80)</button>
    </mat-menu>

    <mat-menu #m04="matMenu">
      <div class="example-menu" cdkMenu>
        <button mat-menu-item (click)="doMenu('sysai85')">定時工作建立(sysai85)</button>
      </div>
    </mat-menu>
    <!-- <mat-menu #m05="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="m01d">下單</button>
      <button mat-menu-item [matMenuTriggerFor]="m01a">建檔</button>
      <button mat-menu-item [matMenuTriggerFor]="m01b">查詢</button>
      <button mat-menu-item [matMenuTriggerFor]="m01c">批次</button>
      <button mat-menu-item (click)="doMenu('stock')">股票走勢圖(stock)</button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="doMenu('stkpq08')">技術分析資料[STKLG]查詢(stkpq08)</button>
      <button mat-menu-item (click)="doMenu('stkpq16')">上市櫃財務查詢(stkpq16)</button>
      <button mat-menu-item (click)="doMenu('stkpq17')">下單與財務查詢(stkpq17)</button>
      <button mat-menu-item (click)="doMenu('stkpq18')">回報查詢(stkpq18)</button>
      <button mat-menu-item (click)="doMenu('stkpq19')">玉山證API查詢(stkpq19)</button>
      <button mat-menu-item (click)="doMenu('stkpq20')">股票技術分析手機版(stkpq20)</button>
    </mat-menu> -->

    <mat-menu #m01a="matMenu">
      <button mat-menu-item (click)="doMenu('stkpi01')">股票基本資料建立(stkpi01)</button>
      <button mat-menu-item (click)="doMenu('stkpi13')">群組設定建立(stkpi13)</button>
      <button mat-menu-item (click)="doMenu('stkpi17')">選股中心建立(stkpi17)</button>
      <button mat-menu-item (click)="doMenu('stkpi19')">追蹤股票建立(stkpi19)</button>
      <button mat-menu-item (click)="doMenu('stkpi20')">股票通知訊息建立(stkpi20)</button>
    </mat-menu>
    <mat-menu #m01b="matMenu">
      <button mat-menu-item (click)="doMenu('stkpq13')">股票群組查詢(stkpq13)</button>
      <button mat-menu-item (click)="doMenu('stkpq14')">股票選股中心查詢(stkpq14)</button>
      <button mat-menu-item (click)="doMenu('stkpq15')">群組熱力圖查詢(stkpq15)</button>
      <button mat-menu-item (click)="doMenu('stkpq09')">追蹤股票查詢(stkpq09)</button>
      <button mat-menu-item (click)="doMenu('stkpq10')">股票通知查詢(stkpq10)</button>
    </mat-menu>
    <mat-menu #m01c="matMenu">
      <button mat-menu-item (click)="doMenu('stkpb04')">[作廢]下單作業(stkpb04)</button>
      <button mat-menu-item (click)="doMenu('stkpb05')">資料維護作業(stkpb05)</button>
    </mat-menu>
    <mat-menu #m01d="matMenu">
    </mat-menu>


  </div>

  <mat-menu #s01="matMenu" [ariaLabel]="'股票'">
    <!-- <button mat-menu-item [matMenuTriggerFor]="s01d">下單</button> -->
    <button mat-menu-item [matMenuTriggerFor]="s01a">建檔</button>
    <button mat-menu-item [matMenuTriggerFor]="s01b">查詢</button>
    <button mat-menu-item [matMenuTriggerFor]="s01c">批次</button>
    <button mat-menu-item (click)="doMenu('stock')">股票走勢圖(stock)</button>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="doMenu('stkpq08')">技術分析資料[STKLG]查詢(stkpq08)</button>
    <button mat-menu-item (click)="doMenu('stkpq16')">上市櫃財務查詢(stkpq16)</button>
    <button mat-menu-item (click)="doMenu('stkpq17')">下單與財務查詢(stkpq17)</button>
    <button mat-menu-item (click)="doMenu('stkpq18')">回報查詢(stkpq18)</button>
    <button mat-menu-item (click)="doMenu('stkpq19')">玉山證API查詢(stkpq19)</button>
    <button mat-menu-item (click)="doMenu('stkpq20')">股票技術分析手機版(stkpq20)</button>
  </mat-menu>

  <mat-menu #s01a="matMenu" [ariaLabel]="'建檔'">
    <button mat-menu-item (click)="doMenu('stkpi01')">股票基本資料建立(stkpi01)</button>
    <button mat-menu-item (click)="doMenu('stkpi13')">群組設定建立(stkpi13)</button>
    <button mat-menu-item (click)="doMenu('stkpi17')">選股中心建立(stkpi17)</button>
    <button mat-menu-item (click)="doMenu('stkpi19')">追蹤股票建立(stkpi19)</button>
    <button mat-menu-item (click)="doMenu('stkpi20')">股票通知訊息建立(stkpi20)</button>

  </mat-menu>
  <mat-menu #s01b="matMenu" [ariaLabel]="'查詢'">
    <div class="example-menu" cdkMenu>
      <button mat-menu-item (click)="doMenu('stkpq13')">股票群組查詢(stkpq13)</button>
      <button mat-menu-item (click)="doMenu('stkpq14')">股票選股中心查詢(stkpq14)</button>
      <button mat-menu-item (click)="doMenu('stkpq15')">群組熱力圖查詢(stkpq15)</button>
      <button mat-menu-item (click)="doMenu('stkpq09')">追蹤股票查詢(stkpq09)</button>
      <button mat-menu-item (click)="doMenu('stkpq10')">股票通知查詢(stkpq10)</button>
    </div>
  </mat-menu>
  <mat-menu #s01c="matMenu" [ariaLabel]="'批次'">
    <div class="example-menu" cdkMenu>
      <button mat-menu-item (click)="doMenu('stkpb04')">[作廢]下單作業(stkpb04)</button>
      <button mat-menu-item (click)="doMenu('stkpb05')">資料維護作業(stkpb05)</button>
    </div>
  </mat-menu>
  <mat-toolbar>
    <button class="btn" [class.btn-primary]="true" [matMenuTriggerFor]="s01">
      <mat-icon>menu</mat-icon>
      股票menu
    </button>
    <app-jkmenu (onReady)="doComReady($event,'jkmenu')">...</app-jkmenu>
    <div class="div-flex">
      <button class="btn btn-primary" (click)="navigateTo('mtr/mtrki01')" matTooltip="mtrki01">
        TODO桌面版
      </button>
      <button class="btn btn-primary" (click)="navigateTo('mtr/mtrki04')" matTooltip="mtrki04">
        TODO行動版
      </button>
    </div>
  </mat-toolbar>


  <ng-template #s01d>
    <div class="example-menu" cdkMenu>

    </div>
  </ng-template>
  <div>
<!--     <div class="p-4">
      <div class="flex flex-wrap gap-4">
        @for(page of myPages; track page.id) {
        <button [routerLink]="getRoute(page.url)" [title]="page.url"
          class="px-4 py-2 bg-blue-600 text-white rounded shadow hover:bg-blue-700 transition">
          {{ page.title }}
        </button>
        }
      </div>
    </div>
 -->  </div>

</div>
<app-home-bottom class="fixed bottom-0 w-full" (onReady)="doComReady($event,'home-bottom')">
</app-home-bottom>
